import Cookies from 'js-cookie';
import * as Logger from '../../common/tools/logger';
import {
  BRAND_DOMAIN,
  COOKIE_IDENTIFIER_UICID
} from './config';

/**
 * Function to modify the `ui_cid` cookie, based on the users permission
 * @param {boolean} permission The users permission
 */
const setUiCidCookie = (permission: boolean): void => {
  const currentValue: string = Cookies.get(COOKIE_IDENTIFIER_UICID);
  if (permission && currentValue === 'OPTOUT') {
    Cookies.remove(COOKIE_IDENTIFIER_UICID, {
      domain: BRAND_DOMAIN,
      path: '/',
      secure: window.location.protocol === 'https:' ? true : false,
    });
  } else if (!permission && currentValue !== 'OPTOUT') {
    Cookies.set(COOKIE_IDENTIFIER_UICID, `OPTOUT`, {
      domain: BRAND_DOMAIN,
      expires: 90,
      path: '/',
      secure: window.location.protocol === 'https:' ? true : false,
    });
  }
}

/**
 * Changes the value of the `ui_cid` cookie, based on the following business rule via the TCF API:
 * Purpose.P1 & Purpose.P5 & Purpose.P6 & Purpose.P8 & Purpose.P10 & Special Feature 1
 */
export const updateUiCidCookie = (): void => {
  if (typeof window.__tcfapi !== 'function') {
    Logger.error(`Compat`, `updateUiCidCookie`, `TCF API not initialized, not able to update the 'ui_cid' cookie.`);
    return;
  }

  try {
    let purposePermission = false,
        specialPermission = false,
        uiCidPermission = false;

    window.__tcfapi('getPermission', 2, (permission: boolean) => {
        purposePermission = permission;
    }, 'publisher', [1, 5, 6, 8, 10]);

    window.__tcfapi('getPermission', 2, (permission: boolean) => {
        specialPermission = permission;
    }, 'special', 1);

    if (purposePermission && specialPermission) {
        uiCidPermission = true;
    }
    setUiCidCookie(uiCidPermission);
  } catch (error) {
    Logger.error(`TCF`, `updateUiCidCookie`, `Failed to update the 'ui_cid' cookie.`, error);
  }
}
